'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$BySiteAndGroup(site, code) {
  this.Xq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.Xp = null;
  this.Xq = site;
  this.Xp = code;
}
export { $c_Lpresto_CredentialsView$BySiteAndGroup as $c_Lpresto_CredentialsView$BySiteAndGroup };
$p = $c_Lpresto_CredentialsView$BySiteAndGroup.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$BySiteAndGroup;
/** @constructor */
function $h_Lpresto_CredentialsView$BySiteAndGroup() {
}
export { $h_Lpresto_CredentialsView$BySiteAndGroup as $h_Lpresto_CredentialsView$BySiteAndGroup };
$h_Lpresto_CredentialsView$BySiteAndGroup.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_CredentialsView$BySiteAndGroup)) {
    var this$1 = this.Xq;
    var b = x$0.Xq;
    if (((this$1.e === b.e) && (this$1.f === b.f))) {
      return (this.Xp === x$0.Xp);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "BySiteAndGroup";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Xq;
  }
  if ((n === 1)) {
    return this.Xp;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_CredentialsView$BySiteAndGroup(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hZ)));
}
export { $isArrayOf_Lpresto_CredentialsView$BySiteAndGroup as $isArrayOf_Lpresto_CredentialsView$BySiteAndGroup };
var $d_Lpresto_CredentialsView$BySiteAndGroup = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$BySiteAndGroup, "presto.CredentialsView$BySiteAndGroup", ({
  hZ: 1,
  e9: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_CredentialsView$BySiteAndGroup as $d_Lpresto_CredentialsView$BySiteAndGroup };
//# sourceMappingURL=presto.-Credentials-View$-By-Site-And-Group.js.map
